// Copyright 2025 Sorama B.V.

import { IParameterizedValueConverter } from "aurelia-binding-ext";
import { NotSupportedError } from "errors/NotSupportedError";

export class EmptyToBooleanValueConverter implements IParameterizedValueConverter<boolean, unknown[], boolean> {
    public toView(value: unknown[], param?: boolean): boolean {
        if (!value) return param;

        return value.length === 0 ? param : !param;
    }

    public fromView(value: boolean, param?: boolean): unknown[] {
        throw new NotSupportedError("Conversion from 'boolean' to 'empty' is not supported.");
    }
}
